import React, { useEffect, useState } from "react";
import "../assets/transactions/SavingTransactionForm.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import axios from "axios";
import { toast } from "react-toastify";

const API_URL = "https://narrowitsolution.in/api";

const SavingAccountTransaction = () => {
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.userProfile);

  const [accounts, setAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);

  const [formData, setFormData] = useState({
    amount: "",
    transactionType: "",
    paymentMode: "CASH",
    transactionDate: "",
    narration: "",
  });

//   console.log("sleec",selectedAccount?.id)
  /* ================= FETCH PROFILE ================= */
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  /* ================= FETCH SAVING ACCOUNTS ================= */
  useEffect(() => {
      const fetchAccounts = async () => {
        try {
          const res = await axios.get(`${API_URL}/get-all-saving-account`, {
            params: {
              superAdminId: profile.superAdminId || 14,
              branchId: profile.branchId || 8,
              createdBy: localStorage.getItem("userId"),
            },
          });
  
          const list = res.data?.accounts || [];
          setAccounts(list);
  
          // Auto-select first account (UX improvement)
          // if (list.length > 0) {
          //   setSelectedAccount(list[0]);
          // }
        } catch (err) {
          toast.error(err?.response?.data?.message || "Failed to fetch accounts");
        }
      };
    if (!profile) return;


    fetchAccounts();
  }, [profile]);

  /* ================= HANDLE INPUT ================= */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedAccount) {
      toast.warn("Please select saving account");
      return;
    }

    if (
      !formData.amount ||
      !formData.transactionType ||
      !formData.transactionDate
    ) {
      toast.warn("Please fill all required fields");
      return;
    }

    if (
      formData.transactionType === "WITHDRAWAL" &&
      Number(formData.amount) > Number(selectedAccount.currentBalance)
    ) {
      toast.warn("Withdrawal amount exceeds available balance");
      return;
    }

    try {
      const payload = {
        savingAccountId: selectedAccount.id,
        amount: Number(formData.amount),
        transactionType: formData.transactionType,
        paymentMode: formData.paymentMode,
        transactionDate: formData.transactionDate,
        remarks: formData.narration,
        status:"Paid",
        employeeId: localStorage.getItem("userId"),
        createdBy: localStorage.getItem("userId"),
      };

      const url =
        formData.transactionType === "DEPOSIT"
          ? "/saving-account/bank/deposit"
          : "/saving-account/bank/withdraw";

     const res= await axios.post(`${API_URL}${url}`, payload);

      toast.success(res?.data?.message||"Transaction successful");

      setFormData({
        amount: "",
        transactionType: "",
        paymentMode: "CASH",
        transactionDate: "",
        narration: "",
      });
      setSelectedAccount(null);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Transaction failed");
    }
  };

  return (
    <div className="saving-account-transaction-container">
      <h2>Transaction Form</h2>

      <form
        className="saving-account-transaction-payment-details"
        onSubmit={handleSubmit}
      >
        <h4>
          <i className="fa-solid fa-credit-card"></i> Payment Details
        </h4>

        <div className="payment-details-container">
          {/* Row 1 */}
          <div className="payment-details-input-groups">
            <div className="payment-details-inputs">
              <label>Saving Account</label>
              <select
                value={selectedAccount?.id || ""}
                onChange={(e) => {
                  const acc = accounts.find(
                    (a) => a.id === Number(e.target.value)
                  );
                  setSelectedAccount(acc || null);
                }}
              >
                <option value="">Select Account</option>
                {accounts.map((acc) => (
                  <option key={acc.id} value={acc.id}>
                    {acc.customerName} | {acc.accountNumber}
                  </option>
                ))}
              </select>
            </div>

            <div className="payment-details-inputs">
              <label>Available Balance</label>
              <input
                type="number"
                value={selectedAccount?.currentBalance || ""}
                readOnly
              />
            </div>
          </div>

          {/* Row 2 */}
          <div className="payment-details-input-groups">
            <div className="payment-details-inputs">
              <label>Transaction Amount</label>
              <input
                type="number"
                name="amount"
                value={formData.amount}
                onChange={handleChange}
                placeholder="Enter amount"
              />
            </div>

            <div className="payment-details-inputs">
              <label>Transaction Type</label>
              <select
                name="transactionType"
                value={formData.transactionType}
                onChange={handleChange}
              >
                <option value="">Select Type</option>
                <option value="DEPOSIT">DEPOSIT</option>
                <option value="WITHDRAWAL">WITHDRAWAL</option>
              </select>
            </div>
          </div>

          {/* Row 3 */}
          <div className="payment-details-input-groups">
            <div className="payment-details-inputs">
              <label>Payment Mode</label>
              <select
                name="paymentMode"
                value={formData.paymentMode}
                onChange={handleChange}
              >
                <option value="CASH">CASH</option>
              </select>
            </div>

            <div className="payment-details-inputs">
              <label>Transaction Date</label>
              <input
                type="date"
                name="transactionDate"
                value={formData.transactionDate}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Row 4 */}
          <div className="payment-details-input-groups">
            <div className="payment-details-inputs">
              <label>Narration</label>
              <input
                type="text"
                name="narration"
                value={formData.narration}
                onChange={handleChange}
                placeholder="Optional narration"
              />
            </div>
          </div>
        </div>

        <div className="pay-btn">
          <button type="submit">Pay</button>
        </div>
      </form>
    </div>
  );
};

export default SavingAccountTransaction;
